import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import { Activity } from '../interfaces/Social';

type FeedRecord = {
  key: string;
  activities: Activity[];
};

type ListState = {
  [key: number]: FeedRecord;
};
type StatusState = {
  [key: number]: string;
};

const list = createReducer<ListState>(
  {},
  {
    [ActionTypes.FETCH_FEED_SUCCESS]: (state, { payload }) => {
      return Object.assign({}, state, {
        [payload.key]: {
          key: payload.key,
          activities: mergeFeedArray(
            state[payload.key] ? state[payload.key].activities : [],
            payload.activities
          )
        }
      });
    },
    [ActionTypes.CLEAR_FEEDS]: () => ({})
  }
);

const mergeFeedArray = (a, b) =>
  [...a, ...b].filter((activity, i, a) => a.findIndex(x => x.id === activity.id) === i);

const setStatusForKey = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.key]: type });

const status = createReducer<StatusState>(
  {},
  {
    [ActionTypes.FETCH_FEED_REQUEST]: setStatusForKey,
    [ActionTypes.FETCH_FEED_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_FEED_NOT_FOUND]: setStatusForKey,
    [ActionTypes.FETCH_FEED_ERROR]: setStatusForKey
  }
);

export default combineReducers({
  list,
  status
});
